export const UrlMixin = {
    data () {
        return {
        }
    },
    methods: {
        getUrl(base) {
            return base + (this.$store.state.isTest ? '?test=1' : '');
        }
    }
};